import get from 'lodash/get'
export default {
  props: {
    navItem: {
      type: Object,
      default: null
    },
  },
  computed: {
    myIndex() {
      return this.navItem.id
    },
    navLink() {
      return get(this.navItem, 'data.url')
    },
    isLink() {
      return !!this.navLink
    },
    subNavVisible() {
      const isLink = this.isLink
      const navItemVisible = this.navItemVisible
      const navVisible = this.navVisible
      return !isLink && navVisible && navItemVisible && navItemVisible.open
    },
  }
}
